export default "__VITE_ASSET__BKvVBuja__"